import type { QueryClient } from "@tanstack/react-query";
import { clearDashboardBrowserStorage } from "@apps/dashboard/lib/clear-dashboard-browser-storage";

/** Tras `authClient.signOut()`: vacía TanStack Query y almacenamiento local del navegador. */
export function afterDashboardSignOut(queryClient: QueryClient): void {
  queryClient.clear();
  clearDashboardBrowserStorage();
}
